module.exports = __webpack_public_path__ + "img/other-solutions.499bd7d4.png";